const isValidDate = (data?: Date) => data && data !== null && data instanceof Date && !Number.isNaN(data.valueOf());

export default isValidDate;
